export const getNoticePeriod = noticePeriodObj => {
	const noticePeriodUnit = noticePeriodObj.unit
		? noticePeriodObj.unit[0].toUpperCase() + noticePeriodObj.unit.slice(1) + '/s'
		: '';
	let notice;
	if (!noticePeriodObj.max && !noticePeriodObj.min) notice = 'Available Immediately';
	else if (noticePeriodObj.min === noticePeriodObj.max || !noticePeriodObj.max)
		notice = `${noticePeriodObj.min} ${noticePeriodUnit}`;
	else {
		notice = `${noticePeriodObj.min} - ${noticePeriodObj.max} ${noticePeriodUnit}`;
	}
	return notice;
};
